export enum ServiceModels {
  Continuity = 1,
  Project = 2,
  Coordinated = 3,
}
